import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentMagentoClient } from "@jti/magento";

const getDefaultShippingMethodsDeclaration = (isFreeTrial: boolean) =>
  createAsyncThunk(
    isFreeTrial ? "freeTrialCheckout/getDefaultShippingMethods" : "checkout/getDefaultShippingMethods",
    async ({ cartId }: { cartId: string; countryCode: string }) =>
      getCurrentMagentoClient(isFreeTrial).getDefaultShippingMethods(cartId)
  );

export const getDefaultShippingMethods = getDefaultShippingMethodsDeclaration(false);
export const getFreeTrialDefaultShippingMethods = getDefaultShippingMethodsDeclaration(true);
